<div
    class="contract--wrapper"
    data-testid="t-contractdata-div-1752672977568-23"
>
    <div
        class="add--header"
        data-testid="t-contractdata-div-1752672977568-4"
    >
        <div
            class="col"
            data-testid="t-contractdata-div-1752672977568-1"
        >
            <span
                class="h5"
                data-testid="t-contractdata-span-1752672977568-1"
                >{{ 'mws.agreement' | i18n }}:</span
            >
        </div>

        <div
            class="col-auto text-end"
            data-testid="t-contractdata-div-1752672977568-3"
        >
            <div
                class="filter--elements d-inline-block"
                data-testid="t-contractdata-div-1752672977568-2"
            >
                <select
                    class="form-select d-inline-block"
                    [attr.aria-label]="'mws.openfilter' | i18n"
                    (change)="filterContracts($any($event.target).value)"
                    [value]="contractfiltervalue"
                    data-testid="t-contractdata-select-1752672977568-1"
                >
                    <option
                        [value]="supplierContractFilter.VALID"
                        [selected]="contractfiltervalue === supplierContractFilter.VALID"
                        data-testid="t-contractdata-option-1752672977568-1"
                    >
                        {{ 'mws.showvalid' | i18n }}
                    </option>
                    <option
                        [value]="supplierContractFilter.ALL"
                        data-testid="t-contractdata-option-1752672977568-2"
                    >
                        {{ 'mws.showall' | i18n }}
                    </option>
                </select>
            </div>

            @if (supplierService.supplierBasedata.updatable) {
                <a
                    class="btn btn-sm action--btn btn-primary"
                    [attr.aria-label]="'mws.add' | i18n"
                    (click)="openNewContractCostcenterModal()"
                    data-testid="t-contractdata-a-1752672977568-1"
                    ><i
                        class="oc-plus"
                        data-testid="t-contractdata-i-1752672977568-1"
                    ></i
                ></a>
            }
        </div>
    </div>

    <div
        class="table-oc-responsive table-responsive table-scrollable contract--select table-datetime collapsible--trigger"
        data-testid="t-contractdata-div-1752672977568-5"
    >
        <table
            cdk-table
            [dataSource]="supplierService.supplierContracts"
            class="table mat-elevation-z8"
            data-testid="t-contractdata-table-1752672977568-1"
        >
            <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container cdkColumnDef="id">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-contractdata-th-1752672977568-1"
                >
                    {{ 'mws.contractid' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-contractdata-td-1752672977568-1"
                >
                    {{ element.id }}
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container cdkColumnDef="dateFrom">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-contractdata-th-1752672977568-2"
                >
                    {{ 'mws.datefrom' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-contractdata-td-1752672977568-2"
                >
                    {{ element.validFrom | ocDatepipe: 'L' }}
                </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container cdkColumnDef="dateTill">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-contractdata-th-1752672977568-3"
                >
                    {{ 'mws.datetill' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-contractdata-td-1752672977568-3"
                >
                    {{ element.validTill | ocDatepipe: 'L' }}
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container cdkColumnDef="costcenters">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-contractdata-th-1752672977568-4"
                >
                    {{ 'mws.costcenter' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-contractdata-td-1752672977568-4"
                >
                    {{ element._costcenterDescription }} ({{ element._costcenterNumber }})
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container cdkColumnDef="edit">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-contractdata-th-1752672977568-5"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    class="text-end"
                    data-testid="t-contractdata-td-1752672977568-5"
                >
                    <a
                        class="btn btn-sm action--btn btn-primary"
                        [attr.ngbtooltip]="'mws.edit' | i18n"
                        data-testid="t-contractdata-a-1752672977568-2"
                    >
                        <i
                            class="ion oc-eye"
                            data-testid="t-contractdata-i-1752672977568-2"
                        ></i>
                    </a>
                </td>
            </ng-container>

            <tr
                cdk-header-row
                *cdkHeaderRowDef="contractColumns"
                data-testid="t-contractdata-tr-1752672977568-1"
            ></tr>
            <tr
                cdk-row
                *cdkRowDef="let row; columns: contractColumns; let i = index"
                [ngClass]="{ selected: selectedRowIndex === i }"
                (click)="chooseContract(row, i)"
                data-testid="t-contractdata-tr-1752672977568-2"
            ></tr>
        </table>
    </div>

    @if (showContractData) {
        <div
            class="contract--data collapsible--content"
            data-testid="t-contractdata-div-1752672977568-22"
        >
            <div
                class="separator"
                data-testid="t-contractdata-div-1752672977568-6"
            >
                <!-- Trenner/Überschrift: Vereinbarung : Kostenstelle XYZ -->
                &nbsp;{{ 'mws.contract' | i18n }} : {{ supplierService.supplierContractDetail?._mainSupplierContractCostcenter?.costcenterNumber }}&nbsp;{{
                    supplierService.supplierContractDetail?._mainSupplierContractCostcenter?.description
                }}
            </div>
            <div
                class="form-elements--wrapper"
                data-testid="t-contractdata-div-1752672977568-11"
            >
                <form
                    class="form"
                    [formGroup]="contractDatepickerForm"
                    (ngSubmit)="submitContractData()"
                    novalidate
                    data-testid="t-contractdata-form-1752672977568-1"
                >
                    <div
                        class="row g-3"
                        data-testid="t-contractdata-div-1752672977568-9"
                    >
                        <div
                            class="form-group col-auto"
                            data-testid="t-contractdata-div-1752672977568-7"
                        >
                            <app-date-picker
                                [updateable]="supplierService.supplierBasedata.updatable"
                                [title]="'mws.datefrom' | i18n"
                                [locale]="environmentService.appSettings.locale.split('_')[0]"
                                [fC]="validFromControl"
                                [schema]="'supplierContract'"
                                [propertyName]="'validFrom'"
                                [options]="validFromPickerOptions"
                                [showClearDate]="true"
                                [disabled]="isActualDate(supplierService.supplierContract.validFrom)"
                                [placeholder]="''"
                                (dateChange)="onDateFromChanged($event)"
                                data-testid="t-contractdata-app-date-picker-1752672977568-1"
                            ></app-date-picker>
                            <!--                        <app-oc-datepicker-->
                            <!--                             [title]="'mws.datefrom' | i18n"-->
                            <!--                            [schema]="'supplierContract'"-->
                            <!--                            [propertyName]="'validFrom'"-->
                            <!--                            [locale]="environmentService.appSettings.locale.split('_')[0]"-->
                            <!--                            [form]="contractDatepickerForm.get('dateFromForm')"-->
                            <!--                            (dateChange)="onDateChanged($event)"-->
                            <!--                        ></app-oc-datepicker>-->
                            <!--
            <div class="btnGroup">
              <button class="button" type="submit">Submit</button>
              <button class="button" type="button" (click)="setTodayDate()">Set Today</button>
              <button class="button" type="button" (click)="resetTomorrowDate()">Reset Tomorrow</button>
              <button class="button" type="button" (click)="clearDate()">Set Empty</button>
              <button class="button" type="button" (click)="disableFrom()">{{!disabledFrom ? 'Disable' : 'Enable'}}</button>
              <p class="error" *ngIf="myForm.controls.myDateFrom.errors && myForm.controls.myDateFrom.errors.required">Date is required!</p>
              <p class="error" *ngIf="myForm.controls.myDateFrom.errors && myForm.controls.myDateFrom.errors.invalidDateFormat">Invalid date format!</p>
            </div>
            -->
                        </div>
                        <div
                            class="col-auto"
                            data-testid="t-contractdata-div-1752672977568-8"
                        >
                            <app-date-picker
                                [updateable]="supplierService.supplierBasedata.updatable"
                                [title]="'mws.datetill' | i18n"
                                [locale]="environmentService.appSettings.locale.split('_')[0]"
                                [fC]="validTillControl"
                                [schema]="'supplierContract'"
                                [propertyName]="'validTill'"
                                [options]="validTillPickerOptions"
                                [showClearDate]="true"
                                (dateChange)="onDateTillChanged($event)"
                                [placeholder]="''"
                                [disabled]="!contractDatepickerForm.get('validFrom').value || !contractDatepickerForm.get('validFrom').value.singleDate"
                                data-testid="t-contractdata-app-date-picker-1752672977568-2"
                            ></app-date-picker>
                            <!--                        <app-oc-datepicker-->
                            <!--                            [title]="'mws.datetill' | i18n"-->
                            <!--                            [locale]="environmentService.appSettings.locale.split('_')[0]"-->
                            <!--                            [form]="contractDatepickerForm.get('dateTillForm')"-->
                            <!--                            [showClearDate]="true"-->
                            <!--                            (dateChange)="onDateChanged($event)"-->
                            <!--                            [disabled]="!contractDatepickerForm.get('dateFromForm').get('date').value || !contractDatepickerForm.get('dateFromForm').get('date').value.singleDate"-->
                            <!--                        ></app-oc-datepicker>-->
                        </div>
                    </div>
                    @if (supplierService.supplierBasedata.updatable) {
                        <div
                            class="button-wrapper"
                            data-testid="t-contractdata-div-1752672977568-10"
                        >
                            <button
                                type="button"
                                id="contractData-cancel"
                                [attr.aria-label]="'button.discard' | i18n"
                                class="btn btn-danger"
                                [disabled]="contractDataChanged"
                                (click)="resetContractData()"
                                data-testid="t-contractdata-button-1752672977568-1"
                            >
                                <i
                                    class="oc-general-cancel"
                                    data-testid="t-contractdata-i-1752672977568-3"
                                ></i>
                            </button>
                            <button
                                type="submit"
                                id="contractData-success"
                                class="btn btn-success"
                                [attr.aria-label]="'button.check' | i18n"
                                [disabled]="contractDataChanged"
                                data-testid="t-contractdata-button-1752672977568-2"
                            >
                                <i
                                    class="oc-general-check"
                                    data-testid="t-contractdata-i-1752672977568-4"
                                ></i>
                            </button>
                        </div>
                    }
                </form>
            </div>
            @if (
                supplierService.supplierContract.id &&
                coreService.checkAbility('execute', 'supplier.contract.discount') &&
                supplierService.supplierBasedata.updatable
            ) {
                <div
                    class="form-elements--wrapper"
                    data-testid="t-contractdata-div-1752672977568-12"
                >
                    <!-- DISCOUNTS / RABATTE -->
                    <app-discounts
                        [updateable]="supplierService.supplierBasedata.updatable"
                        [privilegeContext]="'supplier'"
                        data-testid="t-contractdata-app-discounts-1752672977568-1"
                    ></app-discounts>
                </div>
            }
            @if (supplierService.supplierContract.id) {
                <div data-testid="t-contractdata-div-1752672977568-21">
                    <!-- MainCostcenter : Vertragspartner -->
                    <!-- Diese Vereinbarung wurde mit folgender Kostenstelle abgeschlossen (Grundlage) -->
                    <div
                        class="form-elements--wrapper"
                        data-testid="t-contractdata-div-1752672977568-15"
                    >
                        <div
                            class="add--header"
                            data-testid="t-contractdata-div-1752672977568-13"
                        >
                            <span
                                class="h5"
                                data-testid="t-contractdata-span-1752672977568-2"
                                >{{ 'mws.agreementclosedwith' | i18n }}:</span
                            >
                        </div>
                        <!--            <div *ngFor="let scc of supplierService.supplierContractDetail?.supplierContractCostcenters">-->
                        <!--                &lt;!&ndash; BEDINGUNG: NUR MainCostcenter/Vertragspartner &ndash;&gt;-->
                        <!--                <app-conditions-->
                        <!--                    *ngIf="scc.costcenterId === supplierService.supplierContractDetail.costcenterId"-->
                        <!--                    [scc]="scc"></app-conditions>-->
                        <!--            </div>-->
                        <div
                            class="d-inline-block alert alert-info"
                            data-testid="t-contractdata-div-1752672977568-14"
                        >
                            <!-- BEDINGUNG: NUR MainCostcenter/Vertragspartner -->
                            <!--                <app-conditions-->
                            <!--                    [sc]="supplierService.supplierContractDetail"></app-conditions>-->
                            {{ supplierService.supplierContractDetail._mainSupplierContractCostcenter?.description }}
                            ({{ supplierService.supplierContractDetail._mainSupplierContractCostcenter?.costcenterNumber }})
                        </div>
                    </div>
                    <!-- Vereinbarungsrelevante Kostenstellen -->
                    <!-- Vereinbarungsrelevante Kostenstellen -->
                    <div
                        class="form-elements--wrapper"
                        data-testid="t-contractdata-div-1752672977568-20"
                    >
                        <div
                            class="add--header"
                            data-testid="t-contractdata-div-1752672977568-18"
                        >
                            <div
                                class="col"
                                data-testid="t-contractdata-div-1752672977568-16"
                            >
                                <span
                                    class="h5"
                                    data-testid="t-contractdata-span-1752672977568-3"
                                >
                                    {{ 'mws.viewcostcenters' | i18n }}:
                                    <!--                        {{'mws.deviatingconditions' | i18n}}:-->
                                </span>
                                <!--                    <br/>-->
                                <!--                    (ohne abweichende Bedingung: {{abweichendeBedingungenMoeglich.length}} / mit abweichender Bedingung: {{abweichendeBedingungenBereitsExistent.length}} / insgesamt zugeordnet: {{vereinbarungsrelevante.length}}):-->
                            </div>
                            <div
                                class="col-auto text-end"
                                data-testid="t-contractdata-div-1752672977568-17"
                            >
                                <a
                                    class="btn btn-sm action--btn btn-primary"
                                    [attr.aria-label]="'mws.add' | i18n"
                                    (click)="openCostcenterModalAssignAddMoreCostcenter()"
                                    data-testid="t-contractdata-a-1752672977568-3"
                                >
                                    <i
                                        class="oc-plus"
                                        data-testid="t-contractdata-i-1752672977568-5"
                                    ></i
                                ></a>
                                <a
                                    class="btn btn-danger btn-sm action--btn"
                                    [attr.aria-label]="'mws.delete' | i18n"
                                    (click)="openAssignedCostcenterModal()"
                                    data-testid="t-contractdata-a-1752672977568-4"
                                >
                                    <i
                                        class="oc-trash-can"
                                        data-testid="t-contractdata-i-1752672977568-6"
                                    ></i
                                ></a>
                            </div>
                        </div>
                        @for (scc of supplierService.supplierContractDetail?.supplierContractCostcenters; track scc; let i = $index) {
                            <div data-testid="t-contractdata-div-1752672977568-19">
                                <!-- AUSNAHME: MainCostcenter/Vertragspartner -->
                                <!--                <app-conditions-->
                                <!--                    *ngIf="scc.costcenterId !== supplierService.supplierContractDetail.costcenterId"-->
                                <!--                    [scc]="scc"></app-conditions>-->
                                <app-conditions
                                    [updateable]="isUpdateable(scc.costcenterId)"
                                    [scc]="scc"
                                    [indexSupplierContractCostcenters]="i"
                                    data-testid="t-contractdata-app-conditions-1752672977568-1"
                                ></app-conditions>
                                <!--                <hr *ngIf="scc.costcenterId === supplierService.supplierContractDetail.costcenterId">-->
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>

<!-- Modal template: ROOT Kostenstellen Auswahl -->
<!-- SCHRITT 1: Wählen Sie ihren Vereinbarungspartner/Kostenstelle aus -->
<ng-template
    #costcenterModalRoot
    let-c="close"
    let-d="dismiss"
>
    <app-costcentertree
        [modalMessageTitle]="'mws.modal.chose.root.costcenter.for.contract' | i18n"
        (cancelButton)="cancelCostcenter()"
        (checkButton)="checkRootCostcenterForContract($event)"
        [treeDisabled]="false"
        [multipleSelect]="false"
        [useTriState]="false"
        [nodes]="nodes"
        [d]="d"
        [c]="c"
        [expandAll]="false"
        data-testid="t-contractdata-app-costcentertree-1752672977568-1"
    />
</ng-template>

<!-- Modal template: ASSIGNED Kostenstellen Auswahl -->
<!-- SCHRITT 2: Wählen Sie alle vereinbarungsrelevanten Kostenstellen aus -->
<!-- 1) Vertragsanlage -->
<ng-template
    #costcenterModalAssign
    let-c="close"
    let-d="dismiss"
>
    <app-costcentertree
        [modalMessageTitle]="'mws.modal.chose.relevant.costcenters.for.contract' | i18n"
        (cancelButton)="cancelCostcenter()"
        (checkButton)="checkAssignedCostcenterForContract($event)"
        [treeDisabled]="costcenterTreeDisabled"
        [multipleSelect]="true"
        [useTriState]="false"
        [nodes]="nodes"
        [d]="d"
        [c]="c"
        [expandAll]="costcenterTreeExpandAll"
        data-testid="t-contractdata-app-costcentertree-1752672977568-2"
    />
</ng-template>

<!-- Modal template: ASSIGNED Kostenstellen Auswahl -->
<!-- 2) Zuordnung von weiteren Kostenstellen zum Vertrag -->
<ng-template
    #costcenterModalAssignAddMoreCostcenter
    let-c="close"
    let-d="dismiss"
>
    <app-costcentertree
        [modalMessageTitle]="'SCHRITT 3: Fügen Sie weitere Kostenstellen hinzu'"
        (cancelButton)="cancelCostcenter()"
        (checkButton)="addAssignedCostcenterForContract($event)"
        [treeDisabled]="costcenterTreeDisabled"
        [multipleSelect]="true"
        [useTriState]="false"
        [nodes]="nodes"
        [d]="d"
        [c]="c"
        [expandAll]="costcenterTreeExpandAll"
        data-testid="t-contractdata-app-costcentertree-1752672977568-3"
    />
</ng-template>

<!--
Modal template: Auflistung der zugeordneten Kostenstellen
- alle bereits zugeordneten / vereinbarungsrelevante
-->
<ng-template
    #costcenterListModal
    let-c="close"
    let-d="dismiss"
>
    <app-costcenterlist
        [modalMessageTitle]="costcenterModalHeadline"
        [costcenterList]="costcenterList"
        [showCostcenterListCheckBox]="showCostcenterListCheckBox"
        [displayedCostcenterListColumns]="displayedCostcenterListColumns"
        [d]="d"
        [c]="c"
        (checkButton)="deleteAssignedCostcenter($event)"
        data-testid="t-contractdata-app-costcenterlist-1752672977568-1"
    />
</ng-template>
